// extracted by mini-css-extract-plugin
export var childrenContainer = "_dm-0";
export var virtualScrollArea = "_dm-1";